module.exports = __webpack_public_path__ + "static/media/times-circle.0fda27e6.svg";